<template>
  <div
    :class="['px-2 pb-2', isDesktop && 'absolute bottom-14 right-4 z-20 p-0']"
    data-testid="pinning-feedback"
  >
    <div
      :class="[
        'rounded-lg border border-gray-200 bg-white p-3 shadow-sm',
        isDesktop ? 'w-[280px]' : 'w-full'
      ]"
    >
      <div
        v-if="status === 'success'"
        class="flex min-h-[36px] items-center text-xs text-green-700"
      >
        Thanks for the feedback.
      </div>
      <template v-else>
        <div class="flex items-center justify-between gap-3">
          <div class="text-xs font-medium text-gray-700">How is your session going?</div>
          <div class="flex items-center gap-1">
            <button
              type="button"
              :class="[
                'cursor-pointer rounded-full border border-gray-200 bg-transparent p-1.5 transition-all hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50',
                positive === true && 'border-green-200 bg-green-50 hover:bg-green-100'
              ]"
              :disabled="isSending"
              :aria-pressed="positive === true"
              data-testid="pinning-feedback-thumbs-up"
              @click="emit('select-positive')"
            >
              <UseSvg
                icon="thumbs-up"
                :class="[
                  isDesktop ? 'h-5 w-5' : 'h-4 w-4',
                  positive === true ? 'text-green-600' : 'text-gray-500'
                ]"
              />
            </button>
            <button
              type="button"
              :class="[
                'cursor-pointer rounded-full border border-gray-200 bg-transparent p-1.5 transition-all hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50',
                positive === false && 'border-red-200 bg-red-50 hover:bg-red-100'
              ]"
              :disabled="isSending"
              :aria-pressed="positive === false"
              data-testid="pinning-feedback-thumbs-down"
              @click="emit('select-negative')"
            >
              <UseSvg
                icon="thumbs-up"
                :class="[
                  isDesktop ? 'h-5 w-5' : 'h-4 w-4',
                  positive === false ? 'text-red-600' : 'text-gray-500'
                ]"
                class="rotate-180"
              />
            </button>
          </div>
        </div>

        <div v-if="shouldShowForm" class="mt-3 flex flex-col gap-2">
          <textarea
            :value="message"
            placeholder="Optional details"
            rows="3"
            style="font-size: 16px"
            class="mp-unmask font-inherit w-full resize-none rounded-md border border-gray-300 p-2 outline-none focus:border-blue-500 disabled:opacity-50"
            :disabled="isSending"
            data-testid="pinning-feedback-message"
            @input="emit('update:message', $event.target.value)"
          />
          <div class="flex items-center justify-end gap-2">
            <button
              type="button"
              class="cursor-pointer rounded-md border border-gray-300 bg-transparent px-3 py-1 text-[13px] text-gray-700 hover:bg-gray-50 disabled:opacity-50"
              :disabled="isSending"
              @click="emit('cancel')"
            >
              Cancel
            </button>
            <button
              type="button"
              class="cursor-pointer rounded-[4px] border-none bg-[#414192] px-3 py-1 text-[13px] font-bold !text-white hover:bg-[#06065a] disabled:cursor-not-allowed disabled:opacity-50"
              :disabled="isSending || positive === null"
              @click="emit('submit')"
            >
              {{ isSending ? "Submitting..." : "Submit" }}
            </button>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
import UseSvg from "common/vue/components/UseSvg.vue";
import { computed } from "vue";

defineOptions({ name: "PinningFeedback" });

const props = defineProps({
  positive: { type: [Boolean, null], default: null },
  message: { type: String, default: "" },
  isOpen: { type: Boolean, default: false },
  status: { type: String, default: "idle" },
  isDesktop: { type: Boolean, default: false }
});

const emit = defineEmits([
  "select-positive",
  "select-negative",
  "cancel",
  "submit",
  "update:message"
]);

const isSending = computed(() => props.status === "sending");
const shouldShowForm = computed(() => props.isOpen && props.status !== "success");
</script>
